export const estimateConfig = {
  // Estimate requests are emailed here through FormSubmit (formsubmit.co).
  recipientEmail: 'info@chaconslawncare.com',
  autoResponse:
    'Thank you for contacting Chacon’s Lawncare! We received your Christmas decoration estimate request. We will review your property details and decoration preferences. You do not need to be present while we measure your property. If you asked to be present, we will contact you to coordinate an afternoon visit based on our availability.',
};

export const estimatePropertyTypes = ['Residential', 'Commercial'] as const;

export const estimateServiceOptions = [
  'Roofline Christmas Lights',
  'Wreaths',
  'Bush Lights',
  'Tree Lights',
  'Stake Lights',
  'Garlands',
  'Full Christmas Decoration Package',
  'Other',
];

export const estimateSuccessMessage =
  'Thank you for contacting Chacon’s Lawncare! Your request has been received. We will review your property details and decoration preferences. You do not need to be present while we measure your property. If you requested to be present during the visit, we will contact you to coordinate an afternoon visit based on our availability.';

export const presentVisitMessage =
  'Afternoon visits may be requested. Chacon’s Lawncare will contact you to coordinate a suitable time based on our availability.';
